module.exports = __webpack_public_path__ + "img/model4_zh.571e66af.jpg";